'use client';
import { createContext, type PropsWithChildren, useState } from 'react';
import type { Dictionary } from '@flemingmetrics/api-client';
import { LoadedFile } from '@/types/files';

type LoadedFilesValue = {
  loadedFiles: Dictionary<LoadedFile>;
  addLoadedFile: (id: string | number, file: LoadedFile) => void;
  addLoadedFiles: (files: Dictionary<LoadedFile>) => void;
};

export const LoadedFilesContext = createContext<LoadedFilesValue>({
  loadedFiles: {},
  addLoadedFile: () => null,
  addLoadedFiles: () => null,
});

export default function LoadedFilesProvider({ children }: PropsWithChildren) {
  const [loadedFiles, setLoadedFiles] = useState<
    LoadedFilesValue['loadedFiles']
  >({});

  const handleAddLoadedFile = (id: string | number, file: LoadedFile) => {
    setLoadedFiles((f) => ({ ...f, [id]: file }));
  };

  const handleAddLoadedFiles = (files: Dictionary<LoadedFile>) => {
    setLoadedFiles((f) => ({ ...f, ...files }));
  };

  const contextValue = {
    loadedFiles,
    addLoadedFile: handleAddLoadedFile,
    addLoadedFiles: handleAddLoadedFiles,
  };

  return (
    <LoadedFilesContext.Provider value={contextValue}>
      {children}
    </LoadedFilesContext.Provider>
  );
}
